@if(isLoadingSplash){
<app-splash-screen></app-splash-screen>
} @else{
<div class="login-wrapper">
  <div style="display: flex; align-items: center; justify-content: center">
    <div class="logo-container">
      <img src="assets/logo-login.svg" alt="" height="120px" width="120px" />
    </div>
  </div>

<span class="login-title">Satsang {{ (selectedCountry.value && selectedCountry.value !== 'IN' && appCountryName) ? (appCountryName | titlecase) : '' }} login</span>

  @if(selectedCountry.value! && selectedCountry.value.length>0)
  {
  @if(openSecurityForm){
  <div class="login-card securityform-container">
    @if(securityStep===1){
    <span class="securityform-heading">
      We are unable to find your account. Please provide more information to proceed further. </span>
    }
    @if (securityStep === 2) {
    <span class="securityform-heading">
      From your Arghya Praswasti, please provide the following details to help us verify your identity.
    </span>}
    @if (securityStep === 3) {
    <span class="securityform-heading">
      From your Arghya Praswasti or Dikshya Patra, please provide <b>any one</b> of the following details for
      verification.</span>}

    <div class="progressbar">
      <div class="step" *ngFor="let step of [1, 2, 3, 4]" [class.active]="securityStep >= step"></div>
    </div>

    <form [formGroup]="securityForm" class="securityform-form">
      @if(securityStep === 1){
      <div class="form-group">
        <label for="familyCodeSec">Q. Please enter your Family Code?*</label>
        <input id="familyCodeSec" type="text" formControlName="fcSecurityForm" placeholder="Enter 12 digit family code"
          (keypress)="restrictFCInput($event)" maxlength="12" />
        @if(securityForm.get('fcSecurityForm')?.touched && securityForm.get('fcSecurityForm')?.invalid){
        @if(securityForm.get('fcSecurityForm')?.errors?.['required']){
        <small class="error-text">Please enter Family Code</small>
        }
        @if(securityForm.get('fcSecurityForm')?.errors?.['minlength']){
        <small class="error-text">Please enter a valid Family Code</small>
        }
        }
      </div>

      <div class="form-group">
        <label for="nameAsPerAP">Q. Please enter your Name as per Arghya Praswasti (include middle name & spaces exactly
          as on your Arghya Praswasti) ? *</label>
        <input id="nameAsPerAP" type="text" formControlName="nameAsPerAP" placeholder="Enter Name" />
        @if(securityForm.get('nameAsPerAP')?.touched && securityForm.get('nameAsPerAP')?.errors?.['required']){
        <small class="error-text">Please enter a valid name</small>
        }
      </div>
      }

      @if(securityStep === 2){
      <div class="form-group">
        <label for="dpSerialNo">Q. Please enter your Ritwik's Name?* (include middle name & spaces exactly as on your
          Arghya Praswasti)</label>
        <input id="dpSerialNo" type="text" formControlName="ritwikName" placeholder="Enter ritwik's name" />
        @if(securityForm.get('ritwikName')?.touched && securityForm.get('ritwikName')?.invalid){
        <small class="error-text">Ritwik's Name is required</small>
        }
      </div>
      }

      @if(securityStep === 3){
      <div class="form-group">
        <label for="arghyaSerialNo">Q. Please enter your Arghya Praswasti Serial Number in which you deposited
          Istabhriti ?</label>
        <input id="arghyaSerialNo" type="text" formControlName="arghyaSerialNo"
          placeholder="Enter Arghya Praswasti Serial No" (input)="onSerialChange('arghyaSerialNo')"
          (keypress)="restrictAPSerialInput($event)" maxlength="17" />
      </div>
      <span class="or-divider">OR</span>
      <div class="form-group">
        <label for="dpSerialNo">Q. Please enter your Dikshya Patra Serial Number ?</label>
        <input id="dpSerialNo" type="text" formControlName="dpSerialNo" placeholder="Enter Dp Serial No"
          (input)="onSerialChange('dpSerialNo')" (keypress)="restrictFCInput($event)" />
      </div>
      }

      @if(securityStep === 4){
      @if(isIdentityPresentInSec){
      <div class="form-group">
        <label for="identityNo">Q. Please enter your Identity Number ? *</label>
        <input id="identityNo" type="text" formControlName="identityNo" placeholder="Enter Identity Number" />
        @if (securityForm.get('identityNo')?.touched && securityForm.get('identityNo')?.invalid) {
        <div class="error-text">
          Identity Number is required
        </div>
        }

      </div>
      }
      @else {
      <div class="form-group">
        <label for="recentApSerialNo">Q. Please enter your most recent Arghya Praswasti Serial/Voucher Number in which
          you deposited Istabhriti ? *</label>
        <input id="recentApSerialNo" type="text" formControlName="recentApSerialNo"
          placeholder="Enter Arghya Praswasti Serial No" />
        @if (securityForm.get('recentApSerialNo')?.touched && securityForm.get('recentApSerialNo')?.invalid) {
        <div class="error-text">
          Recent Arghya Praswasti Number is required
        </div>
        }
      </div>

      <div class="form-group">
        <label for="recentApAmount">Q. Please enter the total amount deposited in the above given Arghya Praswasti ?
          *</label>
        <input id="recentApAmount" type="text" formControlName="recentApAmount"
          placeholder="Enter Arghya Praswasti amount" />
        @if (securityForm.get('recentApAmount')?.touched && securityForm.get('recentApAmount')?.invalid) {
        <div class="error-text">
          Recent Arghya Praswasti Amount is required
        </div>
        }
      </div>
      }

      }

      <div class="securityform-footer">
        <!-- <button type="button" class="securityform-btn secondary" (click)="prevSecurityStep()"
          [disabled]="securityStep === 1">
          Back
        </button> -->

        <button type="button" class="securityform-btn primary" (click)="nextSecurityStep()"
          [disabled]="isNextDisabled()">
          @if(isLoading){
          <span class="spinner" role="status" aria-label="Loading"></span>
          }@else{
          Next
          }

        </button>
      </div>

      <div class="securityform-cancel-container">
        <button type="button" class="securityform-cancel-btn" (click)="cancelSecurityFlow()">
          Cancel
        </button>
      </div>
    </form>
  </div>
  }

  @else {
  @if(!state.showOtp){
  <div class="login-card">
    @if (!appCountryId) {
      <div class="country-div">
        <span class="form-label">Select Country/Region to proced</span>
        <app-phil-dropdown placeholder="(Select Country/Region)" [options]="countryList" [isSelectEmit]="true"
          (optionSelected)="onSelectCountry($event)" [control]="selectedCountry"></app-phil-dropdown>
      </div>
    }
    <div class="account-selector">
      @for(account of accounts.accounts;track account){
      <button [class.active]="selectedAccount === account" [style]="accounts.accounts.length==1?'width:100%':''"
        (click)="selectAccount(account)">
        {{ account }}
      </button>
      }
    </div>

    <form [formGroup]="loginForm" style="display: flex; flex-direction: column; gap: 24px">
      @if(selectedAccount === 'Family Code'){
      <ng-container class="fc-container">
        <div class="form-group">
          <label for="familyCode">Family code</label>
          <input id="familyCode" type="text" maxlength="12" formControlName="familyCode"
            placeholder="Enter 12 digit family code" (keypress)="restrictFCInput($event)" maxlength="12" />
          @if(state.fcError){
          <small class="error-text">{{ state.fcError }}</small>
          }
        </div>
        @if (passwordAllowedCountry.includes(selectedCountry.value!)) {
          <div class="form-group">
            <label for="password">Passcode</label>
            <input [ngClass]="isPasswordVisible ? 'open-password' : 'close-password'" [type]="isPasswordVisible ? 'text' : 'password'" style="text-transform: none !important; position: relative" id="password" formControlName="password"
              placeholder="Enter Passcode"/>
            <div class="view-password-btn" (click)="togglePassword()"></div>
          </div>
        }
        @if((state.mobileNumbers.length + state.emails.length) > 1){
        <div style="display: flex; flex-direction: column; gap: 10px">
          <span class="extra-text">
            We’ve detected the following contacts associated with this family code. Please verify one to proceed.
          </span>
          <div class="account-selector" style="flex-wrap: wrap">
            @for(contact of state.mobileNumbers; track contact){
            <button [class]="state.selectedContact === contact ? ' selected-chip' : '' ">
              {{contact }}
            </button>
            }
            @for(email of state.emails; track email){
            <button [class]="state.selectedContact === email ? ' selected-chip' : '' ">{{email}}</button>
            }
          </div>

          <div class="form-group" style="margin-top: 20px;">
            <label for="phone">Enter one Phone number/email from the above list</label>
            <input id="phone" type="text" formControlName="phoneOrEmail" placeholder="Enter your phone number/email"
              style="text-transform: none;" />
            @if(!isValidEmail(getFormControlByname('phoneOrEmail').value) &&
            !isValidPhone(getFormControlByname('phoneOrEmail').value)
            && getFormControlByname('phoneOrEmail').touched){
            <small class="error-text">Enter a valid phone number/email</small>
            }
          </div>
        </div>
        }


      </ng-container>
      } @if(selectedAccount === 'Phone Number'){
      <ng-container class="fc-container">
        <div class="form-group">
          <label for="phone">Phone number</label>
          <input id="phone" type="tel" formControlName="phone" placeholder="Enter your phone number"
            (keypress)="allowOnlyDigits($event)" maxlength="10" />
          @if(getFormControlByname('phone').invalid && getFormControlByname('phone').touched){
          <small class="error-text">Phone number must be exactly 10 digits</small>
          }
        </div>
        @if(state.members.length > 1){
        <div class="form-group">
          <label for="member">We’ve detected more than one account associated with this mobile number. Please select
            and verify one to proceed.</label>
          <app-phil-dropdown placeholder="(Select member)" [options]="state.memberOptions" [isSelectEmit]="true"
            [isAutoFocus]="false" (optionSelected)="onSelectMem($event)">
          </app-phil-dropdown>
        </div>
        }
      </ng-container>
      }@if(selectedAccount == 'Sl. Number'){
      <ng-container class="fc-container">
        <div class="form-group">
          <label for="phone">Serial Number</label>
          <input id="slno" type="tel" formControlName="slno" placeholder="Enter your Serial Number"
            (keypress)="allowOnlyDigits($event)" />
        </div>
        @if((state.mobileNumbers.length + state.emails.length) > 1){
        <div style="display: flex; flex-direction: column; gap: 10px">
          <span class="extra-text">
            We’ve detected the following contacts associated with this member. Please verify one to proceed.
          </span>

          <div class="account-selector" style="flex-wrap: wrap">
            @for(contact of state.mobileNumbers; track contact){
            <button [class]="state.selectedContact === contact ? ' selected-chip' : '' ">
              {{ contact }}
            </button>
            }
            @for(email of state.emails; track email){
            <button [class]="state.selectedContact === email ? ' selected-chip' : '' ">{{email}}</button>
            }
          </div>

          <div class="form-group" style="margin-top: 20px;">
            <label for="phone">Enter one Phone number/email from the above list</label>
            <input id="phone" type="text" formControlName="phoneOrEmail" placeholder="Enter your phone number/email"
              style="text-transform: none;" />
            @if(!isValidEmail(getFormControlByname('phoneOrEmail').value) &&
            !isValidPhone(getFormControlByname('phoneOrEmail').value)
            && getFormControlByname('phoneOrEmail').touched){
            <small class="error-text">Enter a valid phone number/email</small>
            }
          </div>
        </div>
        }
        <!-- @if(members.length > 1){
        <div class="form-group">
          <label for="member">Enter Member</label>
          <app-phil-dropdown placeholder="(Select member)" [options]="memberOptions" [isSelectEmit]="true"
            [isAutoFocus]="false" (optionSelected)="onSelectMem($event)">
          </app-phil-dropdown>
        </div>
        } -->
      </ng-container>
      }

      @if(selectedAccount === 'Email'){
      <ng-container class="fc-container">
        <div class="form-group">
          <label for="email">Email</label>
          <input id="email" type="email" formControlName="email" placeholder="Enter your email"
            style="text-transform: none;" />
          @if(getFormControlByname('email').invalid && getFormControlByname('email').touched){
          <small class="error-text">Enter a valid email</small>
          }
        </div>
      </ng-container>
      }

      <button type="submit" class="login-btn" [disabled]="isLoading || isButtonDisabled().isDisabled"
        (click)="onSubmit()">
        @if(isLoading){
        <span class="spinner" role="status" aria-label="Loading"></span>
        } @else{
        {{ isButtonDisabled().text }}
        }
      </button>
    </form>
  </div>
  }

  @else if (showMemberCard) {
  <div class="login-card">
    <div class="member-header">
      <p class="member-detected-text">
        <span class="icon-text-wrapper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.25 9.25L9.29149 9.22926C9.86461 8.9427 10.5099 9.46034 10.3545 10.082L9.64549 12.918C9.49009 13.5397 10.1354 14.0573 10.7085 13.7707L10.75 13.75M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM10 6.25H10.0075V6.2575H10V6.25Z"
              stroke="white" stroke-opacity="0.66" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="text">We’ve detected more than one account associated with this mobile number. Please select and
            verify one to proceed.</span>
        </span>
      </p>
    </div>


    <div class="member-list">
      @for (member of members; track member.memuuid) {
      <div class="member-card" [class.selected]="selectedMember?.memuuid === member.memuuid"
        (click)="selectMember(member)">
        <div class="avatar-circle">
          {{ member.fullName.charAt(0).toUpperCase() }}
        </div>

        <div class="member-info">
          <span class="member-name">{{ member.fullName }}</span>
          <span class="member-subtitle">Tap to select this profile</span>
        </div>

        <div class="radio-indicator">
          <div class="radio-circle" [class.active]="selectedMember?.memuuid === member.memuuid">
            <span class="radio-dot"></span>
          </div>
        </div>

      </div>
      }
    </div>

    <button class="login-btn" [disabled]="!selectedMember" (click)="continueWithMember()">
      Continue
    </button>
  </div>
  }

  @else {
    <div class="otp-box">
      <div class="form-group">
        <label for="otp">Enter OTP sent to {{otpSentTo}}</label>
        <input type="text" id="otp" [(ngModel)]="this.state.otp" maxlength="6" placeholder="Enter OTP"
          (ngModelChange)="validateOtp()" (keypress)="allowOnlyDigits($event)" />
        @if(state.otpError){
        <small class="error-text">{{ state.otpError }}</small>
        }
      </div>

      <button class="verify-btn" (click)="verifyOtp()">
        @if(isLoading){
        <span class="spinner" role="status" aria-label="Loading"></span>
        } @else{ Verify OTP }
      </button>
      <div class="resend-text mt-3">
        @if(state.countdown !==0){
        <ng-container> Resend OTP in {{ state.countdown }}s </ng-container>
        } @else {
        <span class="resend-link" (click)="resendOTP()">Resend OTP</span>
        }
      </div>
      <div class="resend-text mt-3">
        <span (click)="goBack()" class="back">Back</span>
      </div>
    </div>
  }
  }
  }
  <div style="display: flex;flex-direction: column;gap:42px">
    @if(accounts.createAccount){
    <div class="acc-text" (click)="register()">
      Join us today Create your account
    </div>
    }
    <!-- <span style="font-family: var(--inter);font-size:16px;color:var(--text-tertiary)">Contact US: <a
        [href]="selectedContactUs.contact.href">{{selectedContactUs.contact.value}}</a> or <a
        [href]="selectedContactUs.email.href">{{selectedContactUs.email.value}}</a></span> -->
        @if (selectedContactUs?.items) {
<div class="contact-us-block">
  <div class="contact-us-header">
    <span class="line"></span>
    <span class="contact-us-title">{{ selectedContactUs.title }}</span>
    <span class="line"></span>
  </div>

  @for (item of selectedContactUs.items; track item.label) {
  <span class="contact-us-row">{{ item.label }}:
    <a [href]="item.contact.href">{{ item.contact.value }}</a>
    @if (item.email) { or <a [href]="item.email.href">{{ item.email.value }}</a> }
  </span>
  }
</div>
} @else {
<span class="contact-us-legacy">Contact US:
  <a [href]="selectedContactUs.contact.href">{{ selectedContactUs.contact.value }}</a> or
  <a [href]="selectedContactUs.email.href">{{ selectedContactUs.email.value }}</a>
</span>
}
  </div>
</div>
}